import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";

class ListPopover extends PureComponent {
  static propTypes = {
    isMobile: PropTypes.bool.isRequired,
    className: PropTypes.string,
    contentText: PropTypes.string,
    label: PropTypes.string,
    mouseOver: PropTypes.bool
  };

  static defaultProps = {
    className: "",
    contentText: "",
    label: "",
    mouseOver: false
  };

  state = {
    isContentVisible: false
  };

  componentDidMount() {
    window.addEventListener("click", this.hideContent);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.hideContent);
  }

  buttonRef = React.createRef();

  displayContent = () => {
    window.addEventListener("scroll", this.hideContent, true);
    this.setState({ isContentVisible: true });
  };

  hideContent = () => {
    window.removeEventListener("scroll", this.hideContent, true);
    this.setState({ isContentVisible: false });
  };

  triggerMouseEvent = () => {
    let mouseEvent;
    if (typeof Event !== "function") {
      mouseEvent = document.createEvent("MouseEvent");
      mouseEvent.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    } else {
      mouseEvent = new MouseEvent("click");
    }
    window.dispatchEvent(mouseEvent);
  };

  handleToggleIsContentVisible = e => {
    e.stopPropagation();
    this.triggerMouseEvent();
    if (!this.state.isContentVisible) {
      this.displayContent();
    } else {
      this.hideContent();
    }
  };

  render() {
    const position = this.buttonRef.current && this.buttonRef.current.getBoundingClientRect();
    const popOverStyle = position && this.props.isMobile ? { top: `${position.top + 30}px`, left: `${position.left}px` } : {};

    return (
      <Fragment>
        <button
          ref={this.buttonRef}
          onClick={!this.props.mouseOver ? this.handleToggleIsContentVisible : undefined}
          onMouseEnter={this.props.mouseOver ? this.displayContent : undefined}
          onMouseLeave={this.props.mouseOver ? this.hideContent : undefined}
          className={classNames("list-popover__label", this.props.className)}>
          {this.props.label}
        </button>
        {this.props.contentText &&
          this.state.isContentVisible && (
            <span className="list-popover__content" style={popOverStyle}>
              {this.props.contentText}
            </span>
          )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({ isMobile: state.app.isMobile });

export default connect(mapStateToProps)(ListPopover);



// WEBPACK FOOTER //
// ./src/components/Layout/SortedList/ListPopover.js